import { render, staticRenderFns } from "./flow_templates.vue?vue&type=template&id=5a85e008&scoped=true&"
import script from "./flow_templates.vue?vue&type=script&lang=js&"
export * from "./flow_templates.vue?vue&type=script&lang=js&"
import style0 from "./flow_templates.vue?vue&type=style&index=0&id=5a85e008&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85e008",
  null
  
)

export default component.exports